/**
* Custom tools for recording audio and processing voice on the client
* Copyright Spokestack
* https://github.com/spokestack/node-spokestack/blob/develop/MIT-License.txt
*/
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
} // Polyfill from
// https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia


if (typeof navigator !== 'undefined') {
  navigator.__polyfilledMediaDevices = true; // Older browsers might not implement mediaDevices at all, so we set an empty object first

  if (navigator.mediaDevices === undefined) {
    navigator.mediaDevices = {};
  } // Some browsers partially implement mediaDevices. We can't just assign an object
  // with getUserMedia as it would overwrite existing properties.
  // Here, we will just add the getUserMedia property if it's missing.


  if (navigator.mediaDevices.getUserMedia === undefined) {
    navigator.mediaDevices.getUserMedia = function (constraints) {
      // First get ahold of the legacy getUserMedia, if present
      // eslint-disable-next-line no-var
      var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia; // Some browsers just don't implement it - return a rejected promise with an error
      // to keep a consistent interface

      if (!getUserMedia) {
        var error;

        if (location.protocol !== 'https' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
          error = 'https is required to use getUserMedia on iOS';
        } else {
          error = 'getUserMedia is not implemented in this browser';
        }

        return Promise.reject(new Error(error));
      } // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise


      return new Promise(function (resolve, reject) {
        getUserMedia.call(navigator, constraints, resolve, reject);
      });
    };
  }
}

var stream;

function startRecord() {
  return __awaiter(this, void 0, void 0, function () {
    var constraints, s;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          constraints = {
            autoGainControl: true,
            channelCount: 1,
            echoCancellation: true,
            noiseSuppression: true
          };
          return [4
          /*yield*/
          , navigator.mediaDevices.getUserMedia({
            audio: constraints
          })];

        case 1:
          s = _a.sent();
          return [2
          /*return*/
          , stream = s];
      }
    });
  });
}

function stopRecord() {
  if (stream) {
    stream.getTracks().forEach(function (track) {
      track.stop();
    });
  }

  stream = undefined;
}

var context;
var source;
var processor;
/**
 * Underlying utility method for recording audio,
 * used by the `record` and `recordStream` methods.
 *
 * While createScriptProcessor is deprecated, the replacement (AudioWorklet)
 * does not yet have broad support (currently only supported in Blink browsers).
 * See https://caniuse.com/#feat=mdn-api_audioworkletnode
 *
 * We'll switch to AudioWorklet when it does.
 */

function startProcessor() {
  return __awaiter(this, void 0, void 0, function () {
    var stream, e_1, context, source, processor;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          stopProcessor();
          _a.label = 1;

        case 1:
          _a.trys.push([1, 3,, 4]);

          return [4
          /*yield*/
          , startRecord()];

        case 2:
          stream = _a.sent();
          return [3
          /*break*/
          , 4];

        case 3:
          e_1 = _a.sent();
          console.error(e_1);
          return [2
          /*return*/
          , [new Error("There was a problem starting the microphone. " + (navigator.__polyfilledMediaDevices ? 'This browser does not support microphone access.' : 'Please check the permission and try again.'))]];

        case 4:
          context = new (window.AudioContext || window.webkitAudioContext)();
          source = context.createMediaStreamSource(stream);
          processor = context.createScriptProcessor(1024, 1, 1);
          source.connect(processor);
          processor.connect(context.destination);
          return [2
          /*return*/
          , [null, {
            context: context,
            processor: processor
          }]];
      }
    });
  });
}
/**
 * Underlying utility method to stop the current processor
 * if it exists and disconnect the microphone.
 */


function stopProcessor() {
  stopRecord();

  if (context && source && processor) {
    source.disconnect(processor);
    processor.disconnect(context.destination);
  }

  context = source = processor = undefined;
}
/**
 * A utility method to concatenate two AudioBuffers
 */


function concatenateAudioBuffers(buffer1, buffer2, context) {
  if (!buffer1 && !buffer2) {
    console.error('Pass at least one buffer');
    return null;
  }

  if (buffer1 && !buffer2) {
    return buffer1;
  }

  if (buffer2 && !buffer1) {
    return buffer2;
  }

  var b1 = buffer1;
  var b2 = buffer2;

  if (b1.numberOfChannels !== b2.numberOfChannels) {
    console.error('Number of channels is not the same!');
    return null;
  }

  if (b1.sampleRate !== b2.sampleRate) {
    console.error("Sample rates don't match!");
    return null;
  }

  var tmp = context.createBuffer(b1.numberOfChannels, b1.length + b2.length, b1.sampleRate);

  for (var i = 0; i < tmp.numberOfChannels; i++) {
    var data = tmp.getChannelData(i);
    data.set(b1.getChannelData(i));
    data.set(b2.getChannelData(i), b1.length);
  }

  return tmp;
}
/**
 * Countdown a number of seconds.
 * This is used by record() to record a certain number of seconds.
 * @param {number} time Number of seconds
 * @param {Function} progress Callback for each second (includes first second)
 * @param {Function} complete Callback for completion
 */


function countdown(time, progress, complete) {
  time = time >> 0;

  if (time > 0) {
    progress(time);
    setTimeout(function () {
      return countdown(time - 1, progress, complete);
    }, 1000);
  } else {
    progress(time);
    complete();
  }
} // Edge and Safari need a polyfill for MediaRecorder

/**
 * A method to record audio for a given number of seconds
 *
 * ```js
 * import { record } from 'spokestack/client'
 *
 * // Record for 3 seconds and return an AudioBuffer
 * const buffer = await record()
 *
 * // Record for 5 seconds, calling onProgress every second
 * const buffer = await record({
 *   time: 5,
 *   onProgress: (remaining) => {
 *     console.log(`Recording..${remaining}`)
 *   }
 * })
 *
 * // Record for 3 seconds, calling onStart when recording starts
 * // Note: recording stops when the Promise resolves
 * const buffer = await record({
 *   time: 5,
 *   onStart: () => {
 *     console.log('Recording started')
 *   }
 * })
 * ```
 *
 * Then create a file for uploading
 * See <a href="#googleASR">googleASR</a> for an example on how
 * to process the resulting audio file
 *
 * ```js
 * import { convertFloat32ToInt16 } from 'spokestack/client'
 *
 * const sampleRate = buffer.sampleRate
 * const file = new File(
 *   // Convert to LINEAR16 on the front-end instead of the server.
 *   // This took <10ms in our testing even on a slow phone.
 *   // It cuts the data over the wire to 1/4 the size.
 *   [convertFloat32ToInt16(buffer.getChannelData(0))],
 *   'recording.raw'
 * )
 * ```
 *
 * The file can then be uploaded using FormData:
 *
 * ```js
 * const formData = new FormData()
 * formData.append('sampleRate', sampleRate + '')
 * formData.append('audio', file)
 * fetch('/asr', {
 *   method: 'POST',
 *   body: formData,
 *   headers: { Accept: 'application/json' }
 * })
 *   .then((res) => {
 *     if (!res.ok) {
 *       console.log(`Response status: ${res.status}`)
 *     }
 *     return res.json()
 *   })
 *   .then(({ text }) => console.log('Processed speech', text))
 *   .catch(console.error.bind(console))
 * ```
 */


function record(config) {
  if (config === void 0) {
    config = {
      time: 3
    };
  }

  return __awaiter(this, void 0, void 0, function () {
    function addToBuffer(e) {
      buffer = concatenateAudioBuffers(buffer, e.inputBuffer, context);
    }

    var _a, time, onProgress, onStart, _b, error, result, buffer, _c, processor, context;

    return __generator(this, function (_d) {
      switch (_d.label) {
        case 0:
          _a = config.time, time = _a === void 0 ? 3 : _a, onProgress = config.onProgress, onStart = config.onStart;
          return [4
          /*yield*/
          , startProcessor()];

        case 1:
          _b = _d.sent(), error = _b[0], result = _b[1];

          if (error) {
            throw error;
          }

          _c = result, processor = _c.processor, context = _c.context;
          processor.addEventListener('audioprocess', addToBuffer);

          if (onStart) {
            onStart();
          }

          return [2
          /*return*/
          , new Promise(function (resolve, reject) {
            countdown(time, function (remaining) {
              if (onProgress) {
                onProgress(remaining);
              }
            }, function () {
              processor.removeEventListener('audioprocess', addToBuffer);
              stopProcessor();

              if (buffer) {
                resolve(buffer);
              } else {
                reject(new Error('There was a problem creating the audio buffer. Please reload and try again.'));
              }
            });
          })];
      }
    });
  });
}
/**
 * A utility method to convert Float32Array audio
 * to an Int16Array to be passed directly to Speech APIs
 * such as Google Speech
 *
 * ```js
 * import { convertFloat32ToInt16, record } from 'spokestack/client'
 *
 * const buffer = await record()
 * const file = new File(
 *   [convertFloat32ToInt16(buffer.getChannelData(0))],
 *   'recording.raw'
 * )
 * ```
 */


function convertFloat32ToInt16(fp32Samples) {
  return new Int16Array(fp32Samples.map(function (value) {
    return value * 32767;
  }));
}

function setCookie(name, value) {
  if (typeof document !== 'undefined') {
    document.cookie = name + "=" + encodeURIComponent(value) + ";path=/";
  }
}

var stop;
/**
 * Returns a function to start recording using a native WebSocket.
 * This assumes the socket is hosted on the current server.
 *
 * ```js
 * import { startStream } from 'spokestack/client'
 *
 * // ...
 * try {
 *   const [ws] = await startStream({
 *    isPlaying: () => this.isPlaying
 *   })
 *   ws.addEventListener('open', () => console.log('Recording started'))
 *   ws.addEventListener('close', () => console.log('Recording stopped'))
 *   ws.addEventListener('message', (e) => console.log('Speech processed: ', e.data))
 * } catch (e) {
 *   console.error(e)
 * }
 * ```
 */

function startStream(_a) {
  var address = _a.address,
      isPlaying = _a.isPlaying;
  return __awaiter(this, void 0, void 0, function () {
    function sendChannelData(e) {
      // Do nothing if we're playing audio
      if (isPlaying()) {
        return;
      }

      if (ws.readyState === ws.OPEN) {
        ws.send(convertFloat32ToInt16(e.inputBuffer.getChannelData(0)));
      }
    }

    var _b, error, result, _c, context, processor, ws;

    return __generator(this, function (_d) {
      switch (_d.label) {
        case 0:
          if (!address) {
            address = (location.protocol === 'https:' ? 'wss:' : 'ws:') + "//" + location.hostname + (location.port ? ":" + location.port : '');
          }

          return [4
          /*yield*/
          , startProcessor()];

        case 1:
          _b = _d.sent(), error = _b[0], result = _b[1];

          if (error) {
            throw error;
          }

          _c = result, context = _c.context, processor = _c.processor;
          ws = new WebSocket(address);
          setCookie('sampleRate', context.sampleRate + '');
          ws.addEventListener('open', function () {
            processor.addEventListener('audioprocess', sendChannelData);
          });
          ws.addEventListener('close', function () {
            processor.removeEventListener('audioprocess', sendChannelData);
          });

          stop = function stopStream() {
            ws.close(1000);
            return stopProcessor();
          }; // Close on error


          ws.addEventListener('error', stop);
          return [2
          /*return*/
          , [ws, result]];
      }
    });
  });
}
/**
 * Stop the current recording stream if one exists.
 *
 * ```js
 * import { stopStream } from 'spokestack/client'
 * stopStream()
 * ```
 */


function stopStream() {
  if (stop) {
    stop();
  }

  stop = undefined;
}

exports.SpeechEventType = void 0;

(function (SpeechEventType) {
  SpeechEventType["Activate"] = "ACTIVATE";
  SpeechEventType["Deactivate"] = "DEACTIVATE";
  SpeechEventType["Timeout"] = "TIMEOUT";
  SpeechEventType["Recognize"] = "RECOGNIZE";
  SpeechEventType["Error"] = "ERROR";
})(exports.SpeechEventType || (exports.SpeechEventType = {}));

exports.Stage = void 0;

(function (Stage) {
  Stage["VadTrigger"] = "vadTrigger";
  Stage["WakewordTrigger"] = "wakeword";
  Stage["KeywordRecognizer"] = "keyword";
})(exports.Stage || (exports.Stage = {}));

var analyserFrequencyAverage$2 = {
  exports: {}
};
var clamp_1 = clamp$1;

function clamp$1(value, min, max) {
  return min < max ? value < min ? min : value > max ? max : value : value < max ? max : value > min ? min : value;
}

var clamp = clamp_1;
var audioFrequencyToIndex = frequencyToIndex$1;

function frequencyToIndex$1(frequency, sampleRate, frequencyBinCount) {
  var nyquist = sampleRate / 2;
  var index = Math.round(frequency / nyquist * frequencyBinCount);
  return clamp(index, 0, frequencyBinCount);
}

var frequencyToIndex = audioFrequencyToIndex;
analyserFrequencyAverage$2.exports = analyserFrequencyAverage.bind(null, 255);
analyserFrequencyAverage$2.exports.floatData = analyserFrequencyAverage.bind(null, 1);

function analyserFrequencyAverage(div, analyser, frequencies, minHz, maxHz) {
  var sampleRate = analyser.context.sampleRate;
  var binCount = analyser.frequencyBinCount;
  var start = frequencyToIndex(minHz, sampleRate, binCount);
  var end = frequencyToIndex(maxHz, sampleRate, binCount);
  var count = end - start;
  var sum = 0;

  for (; start < end; start++) {
    sum += frequencies[start] / div;
  }

  return count === 0 ? 0 : sum / count;
}

var analyserFrequencyAverage$1 = analyserFrequencyAverage$2.exports;
var defaultConfig = {
  bufferLen: 1024,
  smoothingTimeConstant: 0.2,
  minCaptureFreq: 85,
  maxCaptureFreq: 255,
  noiseCaptureDuration: 1,
  minNoiseLevel: 0.3,
  maxNoiseLevel: 0.7,
  avgNoiseMultiplier: 1.2,
  riseDelay: 0,
  fallDelay: 250,
  maxActive: 2000,
  onUpdate: function onUpdate() {// noop
  },
  onVadChange: function onVadChange() {// noop
  }
};
/**
 *  average frequency-based VAD
 *  logic from https://github.com/Jam3/voice-activity-detection
 */

var Vad = function () {
  function Vad(audioContext, config) {
    var _this = this;

    this.setLevels = function () {
      _this.envFreqRange = _this.envFreqRange.filter(function (val) {
        return val;
      }).sort();
      var averageEnvFreq = _this.envFreqRange.length ? _this.envFreqRange.reduce(function (p, c) {
        return Math.min(p, c);
      }, 1) : _this.config.minNoiseLevel || 0.1;
      _this.baseLevel = averageEnvFreq * _this.config.avgNoiseMultiplier;

      if (_this.config.minNoiseLevel && _this.baseLevel < _this.config.minNoiseLevel) {
        _this.baseLevel = _this.config.minNoiseLevel;
      }

      if (_this.config.maxNoiseLevel && _this.baseLevel > _this.config.maxNoiseLevel) {
        _this.baseLevel = _this.config.maxNoiseLevel;
      }

      _this.voiceScale = 1 - _this.baseLevel; // console.log(`VAD: base level: ${this.baseLevel}`)
    };

    this.config = _assign(_assign({}, defaultConfig), config.vad);
    this.baseLevel = 0.3;
    this.voiceScale = 1;
    this.activityCounter = 0;
    this.riseFrames = 0;
    this.fallFrames = 0;
    this.maxActiveFrames = this.config.maxActive;
    this.envFreqRange = [];
    var fftWidth = config.fftWidth || 512;
    this.freqBins = new Uint8Array(fftWidth);
    this.prevVadState = false;
    this.curVadState = false;
    this.vadActive = false;
    this.captureTimeout = 1000;
    this.analyser = audioContext.createAnalyser();
    this.analyser.smoothingTimeConstant = this.config.smoothingTimeConstant;
    this.analyser.fftSize = fftWidth;
  }
  /**
   * connects an AnalyserNode between the specified source and script processor
   * in the audio context so that incoming data can be analyzed for voice
   * activity. The node must be connected before `vadStatus` will work.
   */


  Vad.prototype.connect = function (source, processor) {
    source.connect(this.analyser);
    this.analyser.connect(processor); // we'll receive `bufferSize` samples at a time, so use this to determine
    // activity parameters

    var frameSize = processor.bufferSize;
    var msPerFrame = frameSize / (source.context.sampleRate / 1000);
    this.riseFrames = Math.floor(this.config.riseDelay / msPerFrame);
    this.fallFrames = Math.floor(this.config.fallDelay / msPerFrame);
    this.maxActiveFrames = Math.floor(this.config.maxActive / msPerFrame);
  };

  Vad.prototype.disconnect = function () {
    this.analyser.disconnect();
  };
  /**
   * Analyzes sound for the amount of time specified by
   * `noiseCaptureDuration` to determine a base level of
   * background noise to discount during voice activity detection.
   *
   * The VAD can be run without calibration, but different browsers
   * and input methods can report different sample values for the same
   * level of background noise, so calibration before first use is recommended.
   *
   * The VAD must be `connect`ed before it can be calibrated
   */


  Vad.prototype.calibrate = function (onComplete) {
    var _this = this;

    if (this.analyser.numberOfOutputs === 0) {
      throw new Error('VAD is not connected');
    }

    setTimeout(function () {
      _this.setLevels();

      onComplete();
    }, this.config.noiseCaptureDuration * 1000);
  };
  /**
   * A function to be used as the `onaudioprocess` method of a
   * `ScriptProcessorNode`. Analyzes each audio frame from the source
   * and fires `onUpdate` for every frame and `onVadChange` if the
   * voice activity status changes.
   */


  Vad.prototype.monitor = function () {
    var _a = this.config,
        onVadChange = _a.onVadChange,
        onUpdate = _a.onUpdate;
    var average = this.setActive();

    if (this.prevVadState !== this.vadActive) {
      this.prevVadState = this.vadActive;
      onVadChange(this.vadActive);
    }

    onUpdate(Math.max(0, average - this.baseLevel) / this.voiceScale);
  };
  /**
   * Get the voice activity status for the last frame of audio
   * analyzed by the VAD.
   */


  Vad.prototype.vadStatus = function () {
    this.setActive();
    var changed = false;

    if (this.prevVadState !== this.vadActive) {
      changed = true;
      this.prevVadState = this.vadActive;
    }

    return {
      changed: changed,
      active: this.vadActive
    };
  };

  Vad.prototype.setActive = function () {
    this.analyser.getByteFrequencyData(this.freqBins);
    var average = analyserFrequencyAverage$1(this.analyser, this.freqBins, this.config.minCaptureFreq, this.config.maxCaptureFreq);
    var isSpeech = average >= this.baseLevel;

    if (isSpeech === this.curVadState) {
      this.activityCounter++;
    } else {
      this.curVadState = isSpeech;
      this.activityCounter = 1;
    }

    if (this.curVadState !== this.vadActive) {
      if (this.curVadState && this.activityCounter >= this.riseFrames) {
        this.vadActive = true;
      }

      if (!this.curVadState && this.activityCounter >= this.fallFrames) {
        this.vadActive = false;
      }
    } else if (this.activityCounter >= this.maxActiveFrames) {
      // max activity timeout
      this.curVadState = this.vadActive = false;
    }

    return average;
  };

  return Vad;
}();

var defaultSpeechConfig = {
  sampleRate: 16000,
  fftWidth: 512,
  hopLength: 10
};
/**
 * Spokestack's speech pipeline comprises a voice activity detection (VAD)
 * component and a series of `stage`s that manage voice interaction.
 *
 * Audio is processed off the main thread, currently via a
 * `ScriptProcessorNode` and web worker. Each chunk of audio samples is
 * passed to the worker along with an indication of speech activity, and
 * each of the stages processes it in order to, e.g., detect whether the user
 * said a wakeword or transcribe an occurrence of a keyword. See documentation
 * for the individual stages for more information on their purpose.
 */

var SpeechPipeline = function () {
  /**
   * Create a new speech pipeline.
   *
   * @param config A SpeechPipelineConfig object describing basic
   * pipeline configuration as well as options specific to certain stages
   * (URLs to models, classes for keyword models, etc.).
   */
  function SpeechPipeline(config) {
    var _this = this;

    this.sendBuffer = function (e) {
      if (_this.vad && _this.worker) {
        // check vad
        var vadStatus = _this.vad.vadStatus(); // console.log(`VAD status: ${JSON.stringify(vadStatus)}`)
        // send vad status and audio to worker


        var data = e.inputBuffer.getChannelData(0);

        _this.worker.postMessage({
          audio: data,
          vad: vadStatus.active
        });
      }
    };

    this.config = _assign(_assign({}, config), {
      speechConfig: _assign(_assign({}, defaultSpeechConfig), config.speechConfig)
    });
    var speechConfig = this.config.speechConfig;
    var opts = {};

    if (speechConfig.sampleRate > 0) {
      opts = {
        sampleRate: speechConfig.sampleRate
      };
    }

    var context = this.context = new (window.AudioContext || window.webkitAudioContext)(opts);

    if (context.sampleRate !== speechConfig.sampleRate) {
      console.error('Could not set sampleRate on the AudioContext');
      throw new Error('unsupported_browser');
    }

    var bufferSize = 512;
    var processor = this.processor = context.createScriptProcessor(bufferSize, 1, 1);
    this.vad = new Vad(context, speechConfig); // create a muted GainNode to let the scriptprocessor work in chrome

    var gainNode = this.gainNode = context.createGain();
    gainNode.gain.value = 0.0;
    processor.connect(gainNode);
    gainNode.connect(context.destination);
  }
  /**
   * Start processing audio with the pipeline. If this is the first use of the
   * pipeline, the microphone permission will be requested from the user if
   * they have not already granted it.
   */


  SpeechPipeline.prototype.start = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _a, stream, e_1;

      var _this = this;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this;
            return [4
            /*yield*/
            , this.initWorker()];

          case 1:
            _a.worker = _b.sent();
            _b.label = 2;

          case 2:
            _b.trys.push([2, 4,, 5]);

            return [4
            /*yield*/
            , startRecord()];

          case 3:
            stream = _b.sent();
            return [3
            /*break*/
            , 5];

          case 4:
            e_1 = _b.sent();
            console.error(e_1);
            throw new Error("There was a problem starting the microphone. " + (navigator.__polyfilledMediaDevices ? 'This browser does not support microphone access.' : 'Please check the permission and try again.'));

          case 5:
            try {
              this.source = this.context.createMediaStreamSource(stream);
            } catch (err) {
              // This is thrown by Firefox, which will create an `AudioContext`
              // with a given sample rate, but won't adjust the sample rate of a
              // user's input device, connect an input stream to an audio context
              // with a different sample rate, or expose `sampleRate` in the
              // constraints, capabilities, or settings of the stream's tracks
              // so you can make a new context before the error happens.
              if (err instanceof DOMException && err.name === 'NotSupportedError') {
                throw new Error('unsupported_browser');
              } else {
                throw err;
              }
            }

            this.vad.connect(this.source, this.processor);
            return [2
            /*return*/
            , new Promise(function (resolve) {
              _this.vad.calibrate(function () {
                _this.processor.addEventListener('audioprocess', _this.sendBuffer);

                resolve(_this);
              });
            })];
        }
      });
    });
  };

  SpeechPipeline.prototype.initWorker = function () {
    var _this = this;

    return new Promise(function (resolve, reject) {
      var resolved = false;
      var config = _this.config;
      var worker = new Worker(config.workerUrl || '/spokestack-web-worker.js');
      var workerConfig = {
        speechConfig: config.speechConfig,
        stages: config.stages
      };
      worker.addEventListener('message', function (event) {
        var _a;

        if (event.data) {
          if (event.data.initialized) {
            resolved = true;
            resolve(worker);
            return;
          } // Pass all messages to the client, including errors


          if (config.onEvent) {
            config.onEvent(event.data);
          }

          if (!event.data.error) {
            return;
          }
        }

        console.error(event);

        _this.stop();

        if (!resolved) {
          reject(new Error(((_a = event.data) === null || _a === void 0 ? void 0 : _a.error) || 'Worker encountered an error and stopped the speech pipeline.'));
          return;
        }
      });
      worker.addEventListener('messageerror', function (event) {
        console.error(event);

        if (!resolved) {
          reject(new Error('Worker hit a serialize error on initialize.'));
          return;
        }

        if (config.onEvent) {
          config.onEvent({
            type: exports.SpeechEventType.Error,
            error: 'A web worker message could not be serialized'
          });
        }
      });
      worker.addEventListener('error', function (event) {
        console.error(event);

        _this.stop();

        if (!resolved) {
          reject(new Error('There was a problem initializing the web worker.'));
          return;
        }

        if (config.onEvent) {
          config.onEvent({
            type: exports.SpeechEventType.Error,
            error: 'The web worker hit an error: ' + event.message
          });
        }
      });
      worker.postMessage({
        config: workerConfig
      });
    });
  };
  /**
   * Stop the pipeline, destroying the internal audio processors and
   * relinquishing the microphone.
   */


  SpeechPipeline.prototype.stop = function () {
    stopRecord();
    this.processor.removeEventListener('audioprocess', this.sendBuffer);
    this.disconnect();

    if (this.worker) {
      this.worker.terminate();
    }
  };

  SpeechPipeline.prototype.disconnect = function () {
    if (this.gainNode && this.processor && this.vad) {
      try {
        this.processor.disconnect(this.gainNode);
      } catch (e) {}

      this.vad.disconnect();
      this.gainNode.disconnect();
    }

    if (this.source) {
      this.source.disconnect();
    }
  };

  return SpeechPipeline;
}();

var _a;
/**
 * Preset profiles for use with startPipeline that include both
 * default configuration and lists of processing stages. Individual
 * stages may require additional configuration that cannot be provided
 * automatically, so see each stage for more details. The stages used
 * by each profile are as follows:
 *
 * - **Keyword**: VadTrigger and KeywordRecognizer:
 *   actively listens for any user speech and delivers a transcript if
 *   a keyword is recognized.
 * - **Wakeword**: WakewordTrigger:
 *   listens passively until a wakeword is recognized, then activates the
 *   pipeline so that ASR can be performed.
 *
 */


exports.PipelineProfile = void 0;

(function (PipelineProfile) {
  // adding a new profile includes adding:
  // - a new `PipelineProfile` member
  // - a new `stagesPresets` member
  // - a new `____Config` interface
  // - a new member in the `PiplineConfig` union

  /**
   * A profile that activates on voice activity and transcribes speech
   * using pretrained keyword recognizer models that support a limited
   * vocabulary.
   */
  PipelineProfile["Keyword"] = "KEYWORD";
  /**
   * A profile that sends an `Activate` event when a wakeword is detected
   * by a set of pretrained wakeword models. Once that event is received,
   * subsequent audio should be sent to a speech recognizer for transcription.
   */

  PipelineProfile["Wakeword"] = "WAKEWORD";
})(exports.PipelineProfile || (exports.PipelineProfile = {}));

var stagesPresets = (_a = {}, _a[exports.PipelineProfile.Keyword] = [exports.Stage.VadTrigger, exports.Stage.KeywordRecognizer], _a[exports.PipelineProfile.Wakeword] = [exports.Stage.WakewordTrigger], _a);
var pipeline;
/**
 * Create and immediately start a SpeechPipeline to process user
 * speech using the specified configuration.
 *
 * To simplify configuration, preset pipeline profiles are provided and
 * can be passed in the config object's `profile` key. See
 * PipelineProfile for more details.
 *
 * **NOTE: The speech pipeline (specifically tensorflow's webgl backend)
 * currently only works in Blink browsers
 * (Chrome, Edge, Opera, Vivaldi, Brave, and most Android browsers)
 * as it requires the use of the experimental
 * [OffscreenCanvas API](https://caniuse.com/?search=offscreencanvas).**
 *
 * First make sure to serve the web worker and tensorflow.js
 * from your node server at the expected locations.
 *
 * For example, with express:
 *
 * ```ts
 * app.use(
 *   '/spokestack-web-worker.js',
 *   express.static(`./node_modules/spokestack/dist/spokestack-web-worker.min.js`)
 * )
 * ```
 *
 * ```ts
 * // Starts a speech pipeline for wakeword processing.
 * try {
 *   await startPipeline({
 *     profile: PipelineProfile.Wakeword,
 *     baseUrls: { wakeword: 'https://s.spokestack.io/u/hgmYb/js' },
 *     onEvent: (event) => {
 *       switch (event.type) {
 *         case SpeechEventType.Activate:
 *           this.setState({ wakeword: { error: '', result: true } })
 *           break
 *         case SpeechEventType.Timeout:
 *           this.setState({ wakeword: { error: 'timeout' } })
 *           break
 *         case SpeechEventType.Error:
 *           console.error(event.error)
 *           break
 *       }
 *     }
 *   })
 * } catch (e) {
 *   console.error(e)
 * }
 * ```
 */

function startPipeline(config) {
  var _a, _b;

  return __awaiter(this, void 0, void 0, function () {
    var speechConfig;
    return __generator(this, function (_c) {
      if (pipeline) {
        pipeline.stop();
      }

      speechConfig = _assign({}, config.speechConfig);

      if (config.keywordClasses) {
        speechConfig.keywordClasses = config.keywordClasses;
      } // Set base URLs


      speechConfig.baseKeywordUrl = (_a = config.baseUrls) === null || _a === void 0 ? void 0 : _a.keyword;
      speechConfig.baseWakewordUrl = (_b = config.baseUrls) === null || _b === void 0 ? void 0 : _b.wakeword;
      pipeline = new SpeechPipeline({
        speechConfig: speechConfig,
        stages: config.stages || stagesPresets[config.profile],
        onEvent: config.onEvent,
        workerUrl: config.workerUrl
      });
      return [2
      /*return*/
      , pipeline.start()];
    });
  });
}
/**
 * Stop the speech pipeline and relinquish its resources,
 * including the microphone.
 *
 * ```ts
 * stopPipeline()
 * ```
 */


function stopPipeline() {
  if (pipeline) {
    pipeline.stop();
    pipeline = undefined;
  }
}

exports.SpeechPipeline = SpeechPipeline;
exports.concatenateAudioBuffers = concatenateAudioBuffers;
exports.convertFloat32ToInt16 = convertFloat32ToInt16;
exports.countdown = countdown;
exports.record = record;
exports.startPipeline = startPipeline;
exports.startProcessor = startProcessor;
exports.startStream = startStream;
exports.stopPipeline = stopPipeline;
exports.stopProcessor = stopProcessor;
exports.stopStream = stopStream;